import ActionType from "./action-type"

const initialState = {
    profileData: {},
    toastOpen: false,
    message: "",
    menuItems: [],
    accountBalance: {},
    dynamicMenus: [],
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.isToastOpen:
            return Object.assign({}, state, { toastOpen: action.open });
        case ActionType.sideBarMenuItems:
            return Object.assign({}, state, { menuItems: action.data })
        case ActionType.profileData:
            return Object.assign({}, state, { profileData: action.data })
        case ActionType.accountBalance:
            return Object.assign({}, state, { accountBalance: action.data })
        case ActionType.dynamicMenu:
            return Object.assign({}, state, { dynamicMenus: action.data })
        case ActionType.logout:
            return initialState
        default:
            return state;
    }
}

export { reducer }